var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _vm.loading === false && _vm.goals.length === 0
        ? _c(
            "Box",
            [
              _vm.donorId
                ? _c("layoutText", [
                    _vm._v("This donor doesn't have any goals")
                  ])
                : _c("layoutText", [_vm._v("Donor is not selected")])
            ],
            1
          )
        : _vm._e(),
      _vm.loading === true || _vm.goals.length > 0
        ? _c(
            "FancySelect",
            _vm._g(
              {
                staticClass: "selector",
                attrs: {
                  options: _vm.goals,
                  loading: _vm.loading,
                  value: _vm.value,
                  clearable: false
                }
              },
              _vm.$listeners
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }